import { createStore } from "redux";
import Userreducers from "./loginReducers";

const store = createStore(Userreducers);

export default store;